import axios from 'axios'

const request = axios.create({
  // baseURL: 'http://dashboardapi.jsjxtzjc.com/'
  baseURL: '/api'
})

request.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token') || ''
    config.headers.Authorization = 'Bearer:' + token
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

request.interceptors.response.use(
  (response) => {
    return response.data
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 导出request对象
export default request
